import { useQuery } from '@tanstack/react-query';
import { getAllVendors, Vendor } from 'api/user/vendor_requests';
import Section from 'components/base/Section';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import StoreItem from 'components/common/StoreItem';
import VendorItems from 'components/common/VendorItems';
import { defaultBreadcrumbItems } from 'data/commonData';
import { stores } from 'data/e-commerce/stores';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const VendorPage = () => {
  const { data: vendors } = useQuery<Vendor[]>({
    queryKey: ['all-vendors'],
    queryFn: getAllVendors
  });

  return (
    <div className="pt-5 mb-9">
      <Container className="px-xl-0 px-xxl-3">
        {/* <Section small className="py-0"> */}
        <div className="mb-5">
          <h2>Vendor List</h2>
          <p className="mb-0 text-body-tertiary fw-semibold">
            Know more about vendors.
          </p>
        </div>
        <Row className="gx-3 gy-5">
          {vendors?.map((item, index) => (
            <Col key={index} xs={6} sm={4} md={3} lg={2}>
              <VendorItems vendor={item} />
            </Col>
          ))}
        </Row>
      </Container>
      {/* </Section> */}
    </div>
  );
};

export default VendorPage;
